import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { path: '/', label: '首页' },
    { path: '/category/ntr-writing', label: '创作技巧' },
    { path: '/category/ntr-recommendations', label: '作品推荐' },
    { path: '/category/ntr-analysis', label: '题材解析' },
    { path: '/category/ntr-appreciation', label: '文化鉴赏' },
    { path: '/category/ntr-elements', label: '剧情要素' },
  ],
  about: [
    { path: '/about', label: '关于我们' },
    { path: '/about#brand', label: '品牌介绍' },
    { path: '/about#testimonials', label: '用户口碑' },
    { path: '/about#contact', label: '联系我们' },
  ],
  resources: [
    { path: '/category/ntr-writing', label: 'NTR创作技巧' },
    { path: '/category/ntr-recommendations', label: 'NTR作品推荐' },
    { path: '/category/ntr-analysis', label: 'NTR题材解析' },
    { path: '/category/ntr-appreciation', label: 'NTR文化鉴赏' },
    { path: '/category/ntr-elements', label: 'NTR剧情要素' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-800">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-primary-400 tracking-wide">
              NTR大师
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              专业NTR内容创作与鉴赏指南平台，致力于为NTR爱好者与创作者提供深度、专业的内容服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">
              <a href="#footer-nav" className="hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">
              <a href="#footer-about" className="hover:text-primary-400 transition-colors">关于</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">
              <a href="#footer-resources" className="hover:text-primary-400 transition-colors">内容资源</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 NTR大师. 本站内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}